// Redux Material Types
export const MATERIAL_FETCH_REQUEST = "MATERIAL_FETCH_REQUEST";
export const MATERIAL_FETCH_SUCCESS = "MATERIAL_FETCH_SUCCESS";
export const MATERIAL_FETCH_FAILURE = "MATERIAL_FETCH_FAILURE";
export const MATERIAL_RESET = "MATERIAL_RESET";
